import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Deploy/Sites — Betreiber-Sicht, nur lesend. Aggregat über
 * alle Deploy-Sites: Sites, Tenants, Deploy-Zähler (gesamt/Erfolge/Fehler), die
 * Erfolgsquote sowie Deploys nach Status der letzten 30 Tage. M2M-Auth wie alle
 * /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  sites: 274,
  tenants: 118,
  deploys: { total: 3812, success: 3617, failed: 195 },
  successRate: 0.9488,
  byStatus: [
    { status: 'success', n: 3617 },
    { status: 'failed', n: 195 },
    { status: 'building', n: 12 },
    { status: 'queued', n: 4 },
  ],
};

export function useDeployStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-deploy', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/deploy');
    },
    refetchInterval: 60_000,
  });
}
